import { useMemo } from "react";
import { useSelector } from "react-redux";

export const useHasMessagesAccess = () => {
  const metaData = useSelector((state: any) => state.metaData);

  const canViewMessages: boolean = useMemo(() => {
    return metaData.featureFlags && metaData.featureFlags.Chat;
  }, [metaData]);

  return { canViewMessages };
};

export const useHasContractMessagesAccess = (
  allowContractChatConversations: boolean,
) => {
  const metaData = useSelector((state: any) => state.metaData);

  const canViewMessages: boolean = useMemo(() => {
    return (
      metaData.featureFlags &&
      metaData.featureFlags.Chat &&
      allowContractChatConversations
    );
  }, [metaData, allowContractChatConversations]);

  return { canViewMessages };
};
